import { useState, useEffect } from 'react';

const usePollTimer = (pollStartTime) => {
  const [pollTimer, setPollTimer] = useState(0);

  useEffect(() => {
    if (pollStartTime) {
      const intervalId = setInterval(() => {
        const elapsedTime = Math.floor((Date.now() - pollStartTime) / 1000);
        setPollTimer(elapsedTime);
      }, 1000);
      return () => clearInterval(intervalId);
    } else {
      setPollTimer(0);
    }
  }, [pollStartTime]);

  return pollTimer;
};

export default usePollTimer;
